<template>
  <div>
    <div class="Search-box">
      <el-form
        ref="searchArea"
        :model="filter"
        size="small"
        label-width="120px"
        label-position="left"
      >
        <el-row :gutter="20">
          <slot name="filter" :filter="filter"></slot>
          <el-col :span="6">
            <!-- <el-form-item> -->
            <el-button
              type="primary"
              @click="getTableData(1)"
              style="margin-bottom: 12px"
              >查询</el-button
            >
            <!-- </el-form-item> -->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row ref="buttonArea" style="margin: 10px 0">
      <slot name="option"></slot>
    </el-row>
    <div class="Table-box">
      <el-table
        :data="data"
        ref="table"
        :height="tableHeight"
        highlight-current-row
        @current-change="handleCurrentChange"
        @selection-change="handleSelectionChange"
      >
        >
        <el-table-column
          v-if="isindex"
          label="序号"
          type="index"
          width="80"
        ></el-table-column>
        <slot name="body"></slot>
      </el-table>

      <div class="pagebox">
        <el-row :gutter="0">
          <el-col
            :span="12"
            style="margin-top: 5px; padding: 15px 10px; font-size: 13px"
          >
            当前显示
            <font color="#4f86fe">
              {{ pageTotal > 0 ? pageSize * (pageIndex - 1) + 1 + "-" : 0 }}
              {{
                pageTotal > 0
                  ? pageSize * pageIndex > pageTotal
                    ? pageTotal
                    : pageSize * pageIndex
                  : ""
              }} </font
            >条

            <span style="margin-top: 5px; color: #4f86fe">{{
              statMessage
            }}</span>
          </el-col>
          <el-col :span="12">
            <el-pagination
              ref="breadCrumb"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 20, 50, 100]"
              @size-change="getTableData(1)"
              @current-change="getTableData()"
              :current-page.sync="pageIndex"
              :page-size.sync="pageSize"
              :total="pageTotal"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import estimateTableHeight from "@/mixins/estimateTableHeight";
export default {
  props: {
    labelWidth: {
      type: String,
    },
    labelPosition: {
      type: String,
    },
    statMessage: {
      type: String,
    },
    url: {
      type: String,
    },
    init: {
      type: Object,
      default: function () {
        return {};
      },
    },
    extendMethod: {
      type: Function,
      default: null, // 默认值为null，表示未传递方法
    },
    handlerdata: {
      type: String,
      default: "mounted",
    },
    isindex: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [estimateTableHeight],
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      filter: { ...this.init },
      data: [],
    };
  },
  mounted() {
    if (this.handlerdata == "mounted") {
      this.getTableData(1);
    }
  },
  activated() {
    if (this.handlerdata == "activated") {
      this.getTableData();
    }
  },
  methods: {
    getTableData(pageIndex) {
      var parm = { ...this.filter };
      if (parm.TypeSelectedDate) {
        parm.TypeSelectedDate = JSON.stringify(parm.TypeSelectedDate);
      }
      if (parm.ScrapId) {
        parm.ScrapId = parm.ScrapId[1];
      }

      if (pageIndex) {
        this.pageIndex = pageIndex;
      }
      this.$get(this.url, {
        ...parm,
        PageNumber: this.pageIndex,
        PageSize: this.pageSize,
      }).then((r) => {
        let list = r.Result;
        let pageTotal = r.Rows;
        if (list.length > 0) {
          let row = list[0];
          this.$refs.table.setCurrentRow(row);
        }
        this.data = list;
        this.pageTotal = pageTotal;
      });

      // 判断extendMethod是否被赋值（即是否传递了方法）
      if (this.extendMethod) {
        // 执行父组件传递过来的方法，并传入参数
        this.extendMethod(parm);
      }
    },
    handleCurrentChange(row) {
      this.$emit("currentrow", row);
    },
    handleSelectionChange(val) {
      this.$emit("selected", val);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>